import apiHelper from './apiHelper';

const getUserIntercomCredentials = async (): Promise<{
  user_id: string,
  intercom_secure_id: string,
}> => {
  const { data }: any = await apiHelper(
    'GET',
    '/personalization/intercom',
    undefined,
    {
      useGateway: true,
    },
  );

  return data;
};

export default getUserIntercomCredentials;
